import React, { useEffect, useCallback, useContext } from "react";
import { makeStyles } from "@material-ui/styles";
import { CircularProgress } from "@material-ui/core";
import useReactRouter from "use-react-router";
import { CheckToken } from "../API/Auth";
import { useSnackbar } from "notistack";
import { LangContext } from "../Context/Langcontext";
import { getUserOne } from "../API/User";

const useStyle = makeStyles((theme) => ({
  root: {
    width: "100%",
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#FFFFFF",
  },
  logo: { width: "auto", height: "5rem" },
  fabProgress: {
    position: "absolute",
    top: -10,
    left: -10,
    zIndex: 1,
  },
  wrapper: {
    margin: theme.spacing(1),
    position: "relative",
  },
}));

const Meaauth = () => {
  const classes = useStyle();
  const { history, location } = useReactRouter();
  const { enqueueSnackbar } = useSnackbar();
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;

  const check = useCallback(async () => {
    const search = location.search;
    const urlParams = new URLSearchParams(search);
    const token = urlParams.get("token");

    if (token) {
      const check = await CheckToken(token);

      if (check.token) {
        setTimeout(async () => {
          localStorage.setItem("role", check.user_role);
          localStorage.setItem("token", token);
          localStorage.setItem("uid", check.user_id);
          const user = await getUserOne(check.user_id);

          console.log(user);
          if (user.status.code === 200) {
            if (user.data[0].mea) {
              localStorage.setItem("mea", check.user_id);
            } else {
            }
          } else {
          }

          if (check.user_role === "admin") {
            history.replace("/app/dashboard");
            enqueueSnackbar(lang.LoginSuccessfully, {
              variant: "success",
            });
          } else if (check.user_role === "root") {
            history.replace("/app/dashboard");
            enqueueSnackbar(lang.LoginSuccessfully, {
              variant: "success",
            });
          } else {
            history.replace("/app");
            enqueueSnackbar(lang.LoginSuccessfully, {
              variant: "success",
            });
          }
        }, 3000);
      } else {
        history.replace("/user/login");
        enqueueSnackbar(check.status.message, {
          variant: "error",
        });
      }
    } else {
      history.replace("/user/login");
    }
  }, [location, history, lang, enqueueSnackbar]);

  useEffect(() => {
    check();
  }, [check]);

  React.useEffect(() => {
    document.title = `MEA-auth | ${lang.MEAtitle}`;
    return () => {};
  }, [lang]);
  return (
    <div className={classes.root}>
      <div className={classes.wrapper}>
        <img
          alt="logo"
          src={require("../images/LOGO/logo3.png")}
          className={classes.logo}
        />
        <CircularProgress size={100} className={classes.fabProgress} />
      </div>
    </div>
  );
};

export default Meaauth;
